module.exports = __webpack_public_path__ + "static/media/goodway-group-logo-white.a44f95ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goodway-group-logo-white.svg
// module id = 1701
// module chunks = 0